
PHI.navigation = {
  init: function() {
    this.bindListeners();
  },

  closeCustomSelectMenu: function() {
    $('.custom-select #ph-selected-item').each(function() {
      if ($(this).hasClass('select-arrow-active')) {
        $(this).next().toggleClass('select-hide');
        $(this).toggleClass('select-arrow-active');
      }
    });
  },

  closeSearchMenu: function() {
    var $el = $('.navigation #searchMenu');

    if ($el.hasClass('open')) {
      $el.trigger('click');
    }
  },

  bindListeners: function() {
    $('.level-1 li').on('mouseenter', function() {
      var level = $(this).parent().prop('className').split(' ')[1];

      PHI.navigation.closeCustomSelectMenu();
      PHI.navigation.closeSearchMenu();
      $('#top-navigation-wrapper').find('.navigation').addClass('hover');
      $(this).addClass('open');

      if (level === 'level-1' || level === 'level-2') {
        PHI.breadcrumb.hide();
      }
    });

    $('.level-1 li').on('mouseleave', function() {
      var level = $(this).parent().prop('className').split(' ')[1];

      $('#top-navigation-wrapper').find('.navigation').removeClass('hover');
      $(this).removeClass('open');

      if (level === 'level-1') {
        PHI.breadcrumb.show();
      }
    });

    $('#top-navigation-wrapper ul.navigation li').on('click', function() {
      var hasChilds = $(this).children('*').has('li').length > 0;

      if (hasChilds || PHI.navigation.isCart(this) || PHI.navigation.isSearch(this)) {
        PHI.navigation.toggle(this);

        if (!PHI.navigation.isCart(this)) {
          PHI.common.closePopover();
        }

        if (!PHI.navigation.isSearch(this)) {
          PHI.breadcrumb.hide();
        }

        // Make sure that other arrows will be removed while we navigate
        $('#top-navigation-wrapper .navigation').addClass('hover');
      }
    });

    $('#search').blur(function() {
      PHI.navigation.toggle('#searchMenu');

      if ($('#search').val() === '') {
        PHI.navigation.toggle('#searchMenu');
      }
    });
    $('.siteSearchSubmit').on('click', function(event) {
      PHI.navigation.closeCustomSelectMenu();
      PHI.common.closePopover();
      PHI.navigation.toggle('#searchMenu');
      $('.my-account').parent().removeClass('open');
      event.stopPropagation();
    });
  },

  isSearch: function(element) {
    return $(element).children('.search').length > 0;
  },

  isCart: function(element) {
    return $(element).children('.shopping-cart').length > 0;
  },
  toggle: function(element) {
    /* eslint-disable no-negated-condition */
    if ($(element).attr('class').indexOf('open') !== -1) {
      $(element).removeClass('open');
    } else {
      $(element).addClass('open');
      /* eslint-enable no-negated-condition */
    }
  }
};

$(function() {
  PHI.navigation.init();
});

$(window).click(function(evt) {
  /* eslint-disable no-undef */
  if (jQuery.inArray('my-account', evt.target.classList) !== -1 || jQuery.inArray('siteSearchSubmit', evt.target.classList) !== -1) {
    /* eslint-enable no-undef */
    return;
  }

  $('#searchMenu').removeClass('open');
  $('.my-account').parent().removeClass('open');
});

$(document).on('visibilitychange', function() {
  if (document.visibilityState === 'hidden') {
    $('#search').val('');
    $('#searchMenu').removeClass('open');
  }
});
